"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
var react_1 = __importDefault(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var Box_1 = require("./Box");
var elementMapping = (_a = {},
    // обратная совместимость
    _a[system_1.TypographyVariants.Header] = 'h1',
    _a[system_1.TypographyVariants.LargeTitle] = 'h2',
    _a[system_1.TypographyVariants.Number] = 'h3',
    _a[system_1.TypographyVariants.Title] = 'h4',
    _a[system_1.TypographyVariants.Headline1] = 'h5',
    _a[system_1.TypographyVariants.Headline2] = 'h6',
    _a[system_1.TypographyVariants.Body] = 'span',
    _a[system_1.TypographyVariants.Subhead] = 'span',
    _a[system_1.TypographyVariants.Caption] = 'span',
    _a[system_1.BGTypographyVariants.Header] = 'h1',
    _a[system_1.BGTypographyVariants.Title1] = 'h2',
    _a[system_1.BGTypographyVariants.Title2] = 'h3',
    _a[system_1.BGTypographyVariants.Title3] = 'h4',
    _a[system_1.BGTypographyVariants.Title4] = 'h5',
    _a[system_1.BGTypographyVariants.Body1] = 'h6',
    _a[system_1.BGTypographyVariants.Body2] = 'span',
    _a[system_1.BGTypographyVariants.Caption1] = 'span',
    _a[system_1.BGTypographyVariants.Caption2] = 'span',
    _a);
var aliasMapping = {
    // обратная совместимость
    header: system_1.TypographyVariants.Header,
    'large-title': system_1.TypographyVariants.LargeTitle,
    number: system_1.TypographyVariants.Number,
    title: system_1.TypographyVariants.Title,
    headline1: system_1.TypographyVariants.Headline1,
    headline2: system_1.TypographyVariants.Headline2,
    body: system_1.TypographyVariants.Body,
    subhead: system_1.TypographyVariants.Subhead,
    caption: system_1.TypographyVariants.Caption,
    'B&G/Header': system_1.BGTypographyVariants.Header,
    'B&G/Title1': system_1.BGTypographyVariants.Title1,
    'B&G/Title2': system_1.BGTypographyVariants.Title2,
    'B&G/Title3': system_1.BGTypographyVariants.Title3,
    'B&G/Title4': system_1.BGTypographyVariants.Title4,
    'B&G/Body1': system_1.BGTypographyVariants.Body1,
    'B&G/Body2': system_1.BGTypographyVariants.Body2,
    'B&G/Caption1': system_1.BGTypographyVariants.Caption1,
    'B&G/Caption2': system_1.BGTypographyVariants.Caption2,
};
var defaultStyles = {
    whiteSpace: 'pre-wrap',
    color: undefined,
};
var colorsMapping = function (theme) { return ({
    main: theme.go.schemes.colors.system.TextMain,
    minor: theme.go.schemes.colors.system.TextMinor,
    invert: theme.go.schemes.colors.system.TextInvert,
}); };
var useStyles = (0, system_1.makeStyles)(function (theme) {
    var _a;
    return (_a = {
            go: {},
            common: function (_a) {
                var _b = _a.color, color = _b === void 0 ? 'main' : _b, whiteSpace = _a.whiteSpace;
                return ({
                    whiteSpace: (whiteSpace !== undefined ? "".concat(whiteSpace, " !important") : undefined),
                    color: colorsMapping(theme)[color],
                });
            },
            font: function (props) { return (__assign(__assign({}, theme.go.mixins.typography.createStyles(props)), defaultStyles)); }
        },
        _a[system_1.TypographyVariants.Header] = __assign(__assign(__assign({}, theme.go.mixins.typography.Header), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.Header.fontWeight;
            } }), defaultStyles),
        _a[system_1.TypographyVariants.LargeTitle] = __assign(__assign(__assign({}, theme.go.mixins.typography.LargeTitle), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.LargeTitle.fontWeight;
            } }), defaultStyles),
        _a[system_1.TypographyVariants.Number] = __assign(__assign(__assign({}, theme.go.mixins.typography.Number), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.Number.fontWeight;
            } }), defaultStyles),
        _a[system_1.TypographyVariants.Title] = __assign(__assign(__assign({}, theme.go.mixins.typography.Title), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.Title.fontWeight;
            } }), defaultStyles),
        _a[system_1.TypographyVariants.Headline1] = __assign(__assign(__assign({}, theme.go.mixins.typography.Headline1), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.Headline1.fontWeight;
            } }), defaultStyles),
        _a[system_1.TypographyVariants.Headline2] = __assign(__assign(__assign({}, theme.go.mixins.typography.Headline2), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.Headline2.fontWeight;
            } }), defaultStyles),
        _a[system_1.TypographyVariants.Body] = __assign(__assign(__assign({}, theme.go.mixins.typography.Body), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.Body.fontWeight;
            } }), defaultStyles),
        _a[system_1.TypographyVariants.Subhead] = __assign(__assign(__assign({}, theme.go.mixins.typography.Subhead), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.Subhead.fontWeight;
            } }), defaultStyles),
        _a[system_1.TypographyVariants.Caption] = __assign(__assign(__assign({}, theme.go.mixins.typography.Caption), { fontWeight: function (_a) {
                var thickness = _a.typographyWeight;
                return thickness
                    ? theme.go.schemes.thickness[thickness]
                    : theme.go.mixins.typography.Caption.fontWeight;
            } }), defaultStyles),
        _a);
});
function Typography(props) {
    var variant = props.variant, className = props.className, color = props.color, whiteSpace = props.whiteSpace, thickness = props.thickness, group = props.group, rest = __rest(props, ["variant", "className", "color", "whiteSpace", "thickness", "group"]);
    var typographyVariant = aliasMapping[variant];
    var styles = useStyles({
        color: color,
        whiteSpace: whiteSpace,
        typographyVariant: typographyVariant,
        typographyWeight: thickness,
        typographyGroup: group,
    });
    return (react_1.default.createElement(Box_1.Box, __assign({ component: elementMapping[typographyVariant], m: "0px" }, rest, { className: (0, utils_1.cn)(className, styles.go, styles.common, styles[typographyVariant] || styles.font) })));
}
exports.Typography = Typography;
